/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import I18Next from "../Control/Vue/I18Next";
import { HandlerType } from "../controls/base/HandlerType";
import { postUrlEncoded } from "../controls/LegacyAxiosUtil";
import { prompt } from "./../Control/Vue/Notifications/Prompts";

export class ChildCredentials implements HandlerType {
	private readonly submitButton: JQuery;
	private readonly passwordInput: JQuery;
	private loading = false;

	constructor(private form: JQuery) {
		this.passwordInput = this.form.find("#child-credentials-password");

		this.submitButton = this.form.find(".mia-submitButton");
		this.submitButton.on("click", (event) => void this.onSubmitButtonClick(event));
	}

	private async onSubmitButtonClick(event: JQuery.Event): Promise<void> {
		event.preventDefault();

		if (this.loading) {
			return;
		}

		const submitURL = this.submitButton.data("url");
		const requestData = {
			firstName: this.form.find("#child-credentials-fname").val(),
			lastName: this.form.find("#child-credentials-lname").val(),
			password: this.passwordInput.val(),
		};

		this.loading = true;
		this.submitButton.button("loading");
		try {
			const response = await postUrlEncoded<{ success: boolean, message?: string, errorMessage?: string }>(submitURL, requestData);
			this.onSubmitDone(response.data);
		}
		finally {
			this.submitButton.button("reset");
			this.loading = false;
		}
	}

	private onSubmitDone(data: { success: boolean, message?: string, errorMessage?: string }) {
		if (data.success && data.message) {
			this.passwordInput.val("");
			prompt(data.message, [{ label: I18Next.tr("OkCancel_Ok"), value: undefined }]);
		}
		else if (data.errorMessage) {
			prompt(data.errorMessage);
		}
	}
}
